import { Outlet } from 'react-router-dom';

function Configuracion() {
  return <Outlet />;
}

export default Configuracion;
